"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const theme_provider_1 = require("../theme-provider");
const text_1 = require("../text");
const isLink = (props) => Boolean(props.tag === 'a');
const isButton = (props) => Boolean(props.tag === 'button');
// color styles for all CTAs
const colorStyle = theme_provider_1.css `
	${props => {
    const textRecipe = props.theme.interaction[props.emphasis === 'primary' ? 'recipe750' : 'recipe450'];
    const transparentRecipe = {
        default: 'transparent',
        disabled: 'transparent',
        hover: 'transparent',
        active: 'transparent'
    };
    const backgroundRecipe = props.emphasis === 'primary'
        ? props.theme.interaction.recipe450
        : transparentRecipe;
    const borderRecipe = props.theme.interaction.recipe450;
    return props.disabled
        ? theme_provider_1.css `
					background: ${backgroundRecipe.disabled};
					border-color: ${borderRecipe.disabled};
					color: ${textRecipe.disabled};
			  `
        : theme_provider_1.css `
					background: ${backgroundRecipe.default};
					border-color: ${borderRecipe.default};
					color: ${textRecipe.default};
			  `;
}};
`;
// hover style for buttons
const hoverButtonStyle = theme_provider_1.css `
	::before {
		content: '';
		background-color: ${props => props.emphasis === 'primary'
    ? props.theme.hoverIndicatorColor.filledElement.default
    : props.theme.hoverIndicatorColor.outlinedElement.default};
		border-radius: 500px; /* any absolute value larger than the largest sensible multi-line button will work */
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
	}
`;
// active style for buttons
const activeButtonStyle = theme_provider_1.css `
	${hoverButtonStyle}
	::before {
		background-color: ${props => props.emphasis === 'primary'
    ? props.theme.hoverIndicatorColor.filledElement.active
    : props.theme.hoverIndicatorColor.outlinedElement.active};
	}
`;
// style for buttons
const buttonStyle = theme_provider_1.css `
	position: relative;
	${props => props.stretchContent && 'width: 100%;'};
	display: inline-flex;
	text-align: center;
	justify-content: center;
	align-items: center;
	${props => {
    const width = props.size === 'small' ? props.theme.size.static400 : '44px';
    const padding = props.size === 'small'
        ? `${props.theme.size.static100} ${props.theme.size.static250}`
        : `0 ${props.theme.size.static450}`;
    const border = props.size === 'small' ? '1px' : '2px';
    const focusPadding = props.size === 'small' ? `2px 0` : `4px 0`;
    return theme_provider_1.css `
				min-height: ${width};
				min-width: ${width};
				${props.circular
        ? theme_provider_1.css `
								width: ${width};
								padding: 0;
						  `
        : theme_provider_1.css `
								padding: ${padding};
						  `}
				border: ${border} solid;
				${!props.disabled &&
        theme_provider_1.css `
						:hover {
							${hoverButtonStyle}
							::before {
								margin: -${border};
							}
						}
						:active {
							${activeButtonStyle}
							::before {
								margin: -${border};
							}
						}
						:focus {
							::after {
								content: '';
								position: absolute;
								width: 100%;
								padding: ${focusPadding};
								height: 100%;
								border-width: 2px 0;
								border-color: ${props => props.theme.focusColor};
								align-self: center;
								border-style: solid;
							}
						}
					`}
			`;
}}
	margin: 0;
	border-radius: 500px; /* any absolute value larger than the largest sensible multi-line button will work */
	outline: none;
	transition: all 0.2s ease-in-out;
	text-decoration: none;
	cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};

	${colorStyle}
`;
// styled component for icons in links
const StyledLinkIcon = theme_provider_1.styled.span.withConfig({ displayName: "StyledLinkIcon", componentId: "sc-11bhekw" }) `
	border-radius: 50%;
	line-height: 0;
	position: relative;
	order: ${props => (props.iconPosition === 'end' ? 1 : 'initial')};
`;
// styled component for icons in buttons
const StyledButtonIcon = theme_provider_1.styled.span.withConfig({ displayName: "StyledButtonIcon", componentId: "sc-t9b6kr" }) `
	order: ${props => (props.iconPosition === 'end' ? 1 : 'initial')};
`;
// styled component for (text-) children in links
const StyledLinkText = theme_provider_1.styled.span.withConfig({ displayName: "StyledLinkText", componentId: "sc-zcwz4o" }) `
	display: inherit;
	position: relative;
	text-decoration: none;
	padding-bottom: 2px;
	border-bottom: 1px solid currentColor;

	${props => props.disabled
    ? theme_provider_1.css `
					pointer-events: none;
					cursor: not-allowed;
			  `
    : theme_provider_1.css `
					cursor: pointer;
			  `}
`;
// style for links
const linkStyle = theme_provider_1.css `
	border: none;
	position: relative;
	text-decoration: none;
	cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
	padding: 0;
	outline: none;

	${colorStyle}

	${props => !props.disabled &&
    theme_provider_1.css `
			:hover,
			:active {
				${StyledLinkText}:only-child {
					::before {
						content: '';
						border-radius: 2px;
						width: 100%;
						height: 100%;
						position: absolute;
					}
				}
				${StyledLinkIcon} {
					::before {
						content: '';
						border-radius: 50%;
						width: 100%;
						height: 100%;
						position: absolute;
					}
				}
			}
			:hover {
				${StyledLinkText}:only-child {
					::before {
						background-color: ${props => props.theme.hoverIndicatorColor.outlinedElement.default};
					}
				}
				${StyledLinkIcon} {
					::before {
						background-color: ${props => props.theme.hoverIndicatorColor.outlinedElement.default};
						box-shadow: 0 0 0
							${props => parseInt(props.theme.size.static350, 10) / 2}px
							${props => props.theme.hoverIndicatorColor.outlinedElement.default};
					}
				}
			}
			:active {
				${StyledLinkText}:only-child {
					::before {
						background-color: ${props => props.theme.hoverIndicatorColor.outlinedElement.active};
					}
				}
				${StyledLinkIcon} {
					::before {
						background-color: ${props => props.theme.hoverIndicatorColor.outlinedElement.active};
						box-shadow: 0 0 0
							${props => parseInt(props.theme.size.static350, 10) / 2}px
							${props => props.theme.hoverIndicatorColor.outlinedElement.active};
					}
				}
			}
			:focus {
				::before {
					content: '';
					position: absolute;
					width: 100%;
					padding: 2px 0;
					height: 100%;
					border-width: 2px 0;
					border-color: ${props => props.theme.focusColor};
					align-self: center;
					border-style: solid;
				}
			}
		`}

	${props => props.isInline
    ? theme_provider_1.css `
					text-align: left;
			  `
    : theme_provider_1.css `
					display: inline-flex;
					align-items: center;
			  `}
`;
// styled component for arranging icons and children in buttons (emphasis primary and secondary, size small and large)
const StyledButtonWrapper = theme_provider_1.styled.div.withConfig({ displayName: "StyledButtonWrapper", componentId: "sc-hqxj01" }) `
	display: grid;
	grid-template-columns: max-content repeat(
			${props => React.Children.count(props.children) - 1},
			auto
		);
	grid-column-gap: ${props => props.theme.size.static150};
	align-items: center;
`;
// styled component for arranging icons and children in links (emphasis tertiary)
const StyledLinkWrapper = theme_provider_1.styled.div.withConfig({ displayName: "StyledLinkWrapper", componentId: "sc-1u1d2au" }) `
	display: grid;
	grid-template-columns: max-content auto;
	grid-column-gap: ${props => props.theme.size.static150};
	align-items: center;
`;
// styled component for large buttons (without icon, emphasis primary and secondary, that actually are buttons)
const StyledButtonAsButton = theme_provider_1.styled.button.withConfig({ displayName: "StyledButtonAsButton", componentId: "sc-185qn3l" }) `
	${buttonStyle}
`;
// styled component for large buttons (without icons, emphasis primary and secondary, that actually are links)
const StyledButtonAsLink = theme_provider_1.styled.a.withConfig({ displayName: "StyledButtonAsLink", componentId: "sc-14frd0" }) `
	${buttonStyle}
`;
// styled component for links (with or without icons, emphasis tertiary, that actually are buttons)
const StyledLinkAsButton = theme_provider_1.styled.button.withConfig({ displayName: "StyledLinkAsButton", componentId: "sc-174sjb1" }) `
	${linkStyle}
`;
// styled component for links (with or without icons, emphasis tertiary, that actually are links)
const StyledLinkAsLink = theme_provider_1.styled.a.withConfig({ displayName: "StyledLinkAsLink", componentId: "sc-gzm1mm" }) `
	${linkStyle}
`;
exports.CTA = React.forwardRef((props, forwardRef) => {
    if (isLink(props)) {
        const { ariaLabel, children, disabled, emphasis = 'primary', icon, iconPosition, size = 'large', 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        tag: _tag, href } = props, rest = __rest(props, ["ariaLabel", "children", "disabled", "emphasis", "icon", "iconPosition", "size", "tag", "href"]);
        const ref = (forwardRef || undefined);
        if (emphasis === 'tertiary') {
            // it is a link, it looks like a link
            return (React.createElement(StyledLinkAsLink, Object.assign({ "aria-label": ariaLabel, disabled: disabled, ref: ref, href: disabled ? undefined : href }, rest, { isInline: !icon }), icon ? (React.Children.count(children) === 0 ? (React.createElement(StyledLinkIcon, null, icon)) : (React.createElement(StyledLinkWrapper, null,
                React.createElement(StyledLinkIcon, { iconPosition: iconPosition }, icon),
                React.createElement(StyledLinkText, { disabled: disabled }, children)))) : (React.createElement(StyledLinkText, { disabled: disabled }, children))));
        }
        else {
            // it is a link, it looks like either a small or a large button
            return (React.createElement(StyledButtonAsLink, Object.assign({ "aria-label": ariaLabel, disabled: disabled, ref: ref, emphasis: emphasis, circular: icon && React.Children.count(children) === 0, size: size, href: disabled ? undefined : href }, rest), icon ? (React.Children.count(children) === 0 ? (React.createElement(StyledButtonIcon, null, icon)) : (React.createElement(StyledButtonWrapper, null,
                React.createElement(StyledButtonIcon, { iconPosition: iconPosition }, icon),
                React.createElement(text_1.Text, { appearance: size === 'small'
                        ? text_1.TextAppearance.label0150
                        : text_1.TextAppearance.label0200, color: text_1.TextColor.inherit, staticSize: true }, children)))) : (React.createElement(text_1.Text, { appearance: size === 'small'
                    ? text_1.TextAppearance.label0150
                    : text_1.TextAppearance.label0200, color: text_1.TextColor.inherit, staticSize: true }, children))));
        }
    }
    else if (isButton(props)) {
        const { ariaLabel, children, disabled, emphasis = 'primary', icon, iconPosition, size = 'large', 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        tag: _tag } = props, rest = __rest(props, ["ariaLabel", "children", "disabled", "emphasis", "icon", "iconPosition", "size", "tag"]);
        const ref = (forwardRef || undefined);
        if (emphasis === 'tertiary') {
            // it is a button, it looks like a link
            return (React.createElement(StyledLinkAsButton, Object.assign({ "aria-label": ariaLabel, disabled: disabled, ref: ref }, rest, { isInline: !icon }), icon ? (React.Children.count(children) === 0 ? (React.createElement(StyledLinkIcon, null, icon)) : (React.createElement(StyledLinkWrapper, null,
                React.createElement(StyledLinkIcon, { iconPosition: iconPosition }, icon),
                React.createElement(StyledLinkText, { disabled: disabled }, children)))) : (React.createElement(StyledLinkText, { disabled: disabled }, children))));
        }
        else {
            // it is a button, it looks like either a small button or a large button
            return (React.createElement(StyledButtonAsButton, Object.assign({ "aria-label": ariaLabel, disabled: disabled, ref: ref, emphasis: emphasis, circular: icon && React.Children.count(children) === 0, size: size }, rest), icon ? (React.Children.count(children) === 0 ? (React.createElement(StyledButtonIcon, null, icon)) : (React.createElement(StyledButtonWrapper, null,
                React.createElement(StyledButtonIcon, { iconPosition: iconPosition }, icon),
                React.createElement(text_1.Text, { appearance: size === 'small'
                        ? text_1.TextAppearance.label0150
                        : text_1.TextAppearance.label0200, color: text_1.TextColor.inherit, staticSize: true }, children)))) : (React.createElement(text_1.Text, { appearance: size === 'small'
                    ? text_1.TextAppearance.label0150
                    : text_1.TextAppearance.label0200, color: text_1.TextColor.inherit, staticSize: true }, children))));
        }
    }
    return null;
});
exports.CTA.displayName = 'CTA';
